import { IStaffDashboardData } from 'src/apis/dashboard/dashboardStaff.interfaces';

export const dashboardStaffMock: IStaffDashboardData = {
  summary: {
    totalCount: 85,
    activeCount: 80,
    attendancePercentage: 96.2,
    expectedCount: 85,
    onLeaveCount: 5,
  },
  attendance: {
    present: 82,
    absent: 3,
    leave: 0,
    holiday: 0,
    late: 2,
  },
  status: {
    active: 80,
    onLeave: 5,
    terminated: 0,
    suspended: 0,
    probation: 0,
  },
  byDepartment: {
    'dept-1': {
      departmentName: 'गणित (Mathematics)',
      totalCount: 25,
      attendance: {
        present: 24,
        absent: 1,
        leave: 0,
        holiday: 0,
        late: 2,
      },
    },
    'dept-2': {
      departmentName: 'विज्ञान (Science)',
      totalCount: 20,
      attendance: {
        present: 19,
        absent: 1,
        leave: 0,
        holiday: 0,
        late: 1,
      },
    },
    'dept-3': {
      departmentName: 'अंग्रेजी (English)',
      totalCount: 15,
      attendance: {
        present: 15,
        absent: 0,
        leave: 0,
        holiday: 0,
        late: 0,
      },
    },
    'dept-4': {
      departmentName: 'हिंदी (Hindi)',
      totalCount: 12,
      attendance: {
        present: 12,
        absent: 0,
        leave: 0,
        holiday: 0,
        late: 0,
      },
    },
    'dept-5': {
      departmentName: 'प्रशासन (Administration)',
      totalCount: 8,
      attendance: {
        present: 7,
        absent: 1,
        leave: 0,
        holiday: 0,
        late: 0,
      },
    },
  },
  byRole: {
    'role-1': {
      roleName: 'शिक्षक (Teacher)',
      totalCount: 72,
      attendance: {
        present: 70,
        absent: 2,
        leave: 0,
        holiday: 0,
        late: 3,
      },
    },
    'role-2': {
      roleName: 'प्रशासक (Administrator)',
      totalCount: 8,
      attendance: {
        present: 7,
        absent: 1,
        leave: 0,
        holiday: 0,
        late: 0,
      },
    },
    'role-3': {
      roleName: 'सहायक कर्मचारी (Support Staff)',
      totalCount: 5,
      attendance: {
        present: 5,
        absent: 0,
        leave: 0,
        holiday: 0,
        late: 0,
      },
    },
  },
  timeSeries: [
    {
      date: '2024-01-01',
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
      total: 130,
      attendancePercentage: 76.9,
    },
    {
      date: '2024-01-02',
      present: 95,
      absent: 8,
      leave: 12,
      holiday: 10,
      total: 125,
      attendancePercentage: 76.0,
    },
    {
      date: '2024-01-03',
      present: 98,
      absent: 9,
      leave: 11,
      holiday: 10,
      total: 128,
      attendancePercentage: 76.6,
    },
    {
      date: '2024-01-04',
      present: 102,
      absent: 7,
      leave: 9,
      holiday: 10,
      total: 128,
      attendancePercentage: 79.7,
    },
    {
      date: '2024-01-05',
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
      total: 130,
      attendancePercentage: 76.9,
    },
  ],
  period: {
    startDate: '2024-01-01',
    endDate: '2024-12-31',
  },
};
